import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';

const RenderPriceInputField = (props) => {
    const {
        className,
        defaultValue,
        dir,
        disabled,
        floatingLabelFixed,
        fullWidth,
        input: {
            name,
            onBlur,
            onChange,
            onFocus,
            value,
        },
        label,
        meta: { touched, error },
        placeholder,
        style,
        type,
    } = props;

    return (
        <TextField
            className={ className }
            defaultValue={ defaultValue }
            dir={ dir }
            disabled={ disabled }
            errorText={ touched && error }
            floatingLabelFixed={ floatingLabelFixed }
            floatingLabelText={ label }
            fullWidth={ fullWidth }
            hintText={ placeholder }
            id={ name }
            onBlur={ onBlur }
            onChange={ onChange }
            onFocus={ onFocus }
            style={ style }
            step={ 1 }
            type={ type }
            value={ value }
        />
    );
};

RenderPriceInputField.defaultProps = {
    floatingLabelFixed: false,
    fullWidth: false,
    type: 'text',
};

RenderPriceInputField.propTypes = {
    className: PropTypes.string,
    defaultValue: PropTypes.string,
    dir: PropTypes.oneOf([
        'rtl',
        'ltr',
    ]),
    disabled: PropTypes.bool,
    floatingLabelFixed: PropTypes.bool,
    fullWidth: PropTypes.bool,
    input: PropTypes.shape({
        name: PropTypes.string.isRequired,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        onDragStart: PropTypes.func,
        onDrop: PropTypes.func,
        onFocus: PropTypes.func,
        value: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string,
        ]),
    }).isRequired,
    label: PropTypes.string.isRequired,
    meta: PropTypes.shape({
        error: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.string,
        ]),
        touched: PropTypes.bool,
    }),
    placeholder: PropTypes.string,
    style: PropTypes.object,
    type: PropTypes.string,
    value: PropTypes.string,
};

export default RenderPriceInputField;



// WEBPACK FOOTER //
// ./src/components/form/InputFields/RenderPriceInputField.js